export default __webpack_public_path__ + "static/media/protractor.bf514787.svg";